import { Disclosure, Transition } from "@headlessui/react";
import styles from "./index.module.css";
import { NavLink, useLocation } from "react-router-dom";
import { RiHome6Line } from "react-icons/ri";
import { TiArrowSortedDown } from "react-icons/ti";
import { TbCategoryPlus } from "react-icons/tb";
import { GrTransaction, GrUserSettings } from "react-icons/gr";
import { CiBarcode } from "react-icons/ci";
import { MdOutlineGroups, MdOutlineDiscount, MdOutlineAudiotrack, MdContactPhone } from "react-icons/md";
import { LiaCreditCardSolid, LiaBlogSolid } from "react-icons/lia";
import { FaQuestion, FaRegEnvelopeOpen } from "react-icons/fa";

const Html = ({ tabclass, isOpen, isAllow }) => {
  const location = useLocation();

  const menus = [
    {
      name: "Dashboard",
      icon: <RiHome6Line className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/dashboard",
      key: "readDashboard",
    },
    {
      name: "Roles",
      icon: <GrUserSettings className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/roles",
      key: "readRoles",
    },
    {
      name: "Sub Admin",
      icon: <TbCategoryPlus className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/subadmin",
      key: "readSub_Admin",
    },
    {
      name: "Sender",
      icon: <MdOutlineGroups className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/users",
      key: "readUsers",
    },
    {
      name: "Categories",
      icon: <TbCategoryPlus className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/category",
      key: "readCategory",
    },
    {
      name: "Sub Categories",
      icon: <TbCategoryPlus className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/subcategory",
      key: "readSub_Category",
    },
    {
      name: "Discount",
      icon: <MdOutlineDiscount className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/discount",
      key: "readDiscount",
    },
    {
      name: "Promo Code",
      icon: <CiBarcode className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/promocode",
      key: "readPromo_Code",
    },
    {
      name: "Audios",
      icon: <MdOutlineAudiotrack className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/audio",
      key: "readAudios",
    },
    {
      name: "Front Image",
      icon: <FaRegEnvelopeOpen className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/envelope",
      key: "readEnvelopes",
    },
    {
      name: "Cards",
      icon: <LiaCreditCardSolid className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/card",
      key: "readCards",
    },
    {
      name: "Blogs",
      icon: <LiaBlogSolid className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/blog",
      key: "readBlogs",
    },
    {
      name: "FAQs",
      icon: <FaQuestion className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/faq",
      key: "readFaqs",
    },
    {
      name: "Transactions",
      icon: <GrTransaction className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/transaction",
      key: "readTransactions",
    },
    {
      name: "Content Management",
      icon: <FaRegEnvelopeOpen className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/content",
      key: "readContent_Management",
    },
    {
      name: "Contact Us",
      icon: <MdContactPhone className="text-[#222222d6] shrink-0 text-lg" />,
      url: "/contactus",
      key: "readContact_Us",
    },
  ];

  return (
    <>
      <div
        className={`px-[8px] ${isOpen && styles.sm_sidebar}`}
        component="siderbar"
      >
        <ul className="space-y-2 px-2">
          {menus.map((itm, index) => {
            return (
              <span key={index}>
                {itm.icon ? (
                  <>
                    <li className="mb-3">
                      {itm.menu ? (
                        <>
                          <Disclosure as="div" defaultOpen={tabclass(itm.tab)}>
                            {({ open }) => (
                              <>
                                <tooltip placement="right" title={itm.name}>
                                  <Disclosure.Button className="w-full p-2.5 rounded-md flex items-center justify-between  bg-[#fff] text-sm font-normal text-[#222222d6] gap-[12px] hover:bg-[#F58D18] transition-all duration-300">
                                    <span className="text-sm font-normal flex items-center gap-[12px] crm">
                                      {itm.icon}
                                      <span className="text-inherit leading-none sidebar_text">
                                        {itm.name}
                                      </span>
                                    </span>
                                    <TiArrowSortedDown
                                      className={`${open ? "" : "-rotate-90 transform"
                                        } h-4 w-4 transition-all duration-500  text-[#222222d6]`}
                                    />
                                  </Disclosure.Button>
                                </tooltip>
                                <Transition
                                  enter="transition duration-300 ease-in-out"
                                  enterFrom="transform scale-95 opacity-0"
                                  enterTo="transform scale-300 opacity-300"
                                  leave="transition duration-300 ease-in-out"
                                  leaveFrom="transform scale-300 opacity-300"
                                  leaveTo="transform scale-95 opacity-0"
                                >
                                  <Disclosure.Panel className="pl-[30px] mt-[4px]">
                                    <ul className="space-y-2">
                                      {itm.menu?.map((sitm, i) => {
                                        return (
                                          <span key={i}>
                                            {isAllow(sitm.key) ? (
                                              <li>
                                                {" "}
                                                <NavLink
                                                  className={(isActive) =>
                                                    "p-2.5 rounded-md block text-sm font-normal text-[#222222d6] cursor-pointer hover:bg-[#F58D18] !no-underline transition-all" +
                                                    (location?.pathname.includes(sitm.url) &&
                                                      "text-[#222222d6] !font-medium")
                                                  }
                                                  to={sitm.url}
                                                >
                                                  <span
                                                    className="text-inherit leading-none sidebar_text"
                                                    title={sitm.name}
                                                  >
                                                    {sitm.name}
                                                  </span>
                                                </NavLink>
                                              </li>
                                            ) : null}
                                          </span>
                                        );
                                      })}
                                    </ul>
                                  </Disclosure.Panel>
                                </Transition>
                              </>
                            )}
                          </Disclosure>
                        </>
                      ) : (
                        <>
                          {isAllow(itm.key) ? (
                            <>
                              <tooltip
                                placement="right"
                                color="#F58D18"
                                title={itm.name}
                              >
                                <NavLink
                                  to={itm.url}
                                  className={(isActive) => "p-2.5 rounded-md flex items-center gap-[12px] text-sm font-normal text-[#222222d6] hover:bg-[#F58D18] !no-underline transition-all group" +
                                    (location?.pathname.includes(itm.url) && "!text-[#fff] !bg-[#F58D18] !font-medium highlighted")
                                  }
                                >
                                  <div className={` ${(location?.pathname.includes(itm.url) && "!text-[#fff] !font-medium highlighted-w")}}`}>
                                    {itm.icon}
                                  </div>
                                  <span className="text-inherit leading-none sidebar_text">
                                    {itm.name}
                                  </span>
                                </NavLink>
                              </tooltip>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <h6
                        className={`${isOpen
                          ? "py-[12px] text-center"
                          : "p-[12px] text-center text-md"
                          } text-xs font-medium text-[#7E8B99] mt-[12px] `}
                      >
                        <span className="sidebar_text text-center">
                          {" "}
                          {itm.name}{" "}
                        </span>
                      </h6>
                    </li>
                  </>
                )}
              </span>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default Html;
